import queryString from 'query-string';

import {
  RECEIVE_SUBSCRIPTIONS_INFO,
  REQUEST_SUBSCRIPTIONS_INFO,
  SUBSCRIPTION_BRAND_TOGGLED,
  SUBSCRIPTION_LIST_TOGGLED,
  SUBSCRIPTION_STOCK_TOGGLED
} from 'constants/reduxActions';

import { authenticationErrorCatchHandlerFactory } from 'actions/errors';
import { getEmailSubscriptions, modifySubscriptions } from 'apis/mafia';
import {
  fetchApiNotAuthenticatedMiddleware,
  fetchErrorMiddleware
} from 'middleware/fetchErrorMiddleware';
import { setSessionCookies } from 'actions/session';
import { prependAppRoot } from 'history/AppRootUtils';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';
import { replaceAuthTokenSpace } from 'helpers/MyAccountUtils';

export function requestSubscriptionsInfo() {
  return {
    type: REQUEST_SUBSCRIPTIONS_INFO
  };
}

export function receiveSubscriptionsInfo(subscriptions) {
  return {
    type: RECEIVE_SUBSCRIPTIONS_INFO,
    subscriptions
  };
}

export function fetchSubscriptionsInfo(getEmailSubscriptionsApi = getEmailSubscriptions) {
  return (dispatch, getState) => {
    dispatch(requestSubscriptionsInfo());
    const { cookies, environmentConfig: { api: { mafia } }, routing: { locationBeforeTransitions, locationBeforeTransitions: { search } } } = getState();
    const { auth_token: emailAuthToken } = queryString.parse(search) || {};

    return getEmailSubscriptionsApi(mafia, cookies, { auth_token: replaceAuthTokenSpace(emailAuthToken) })
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => dispatch(receiveSubscriptionsInfo(resp)))
      .catch(authenticationErrorCatchHandlerFactory(dispatch, prependAppRoot('/subscriptions', locationBeforeTransitions)));
  };
}

export function updateSubscriptions(subscriptions, modifySubscriptionsApi = modifySubscriptions) {
  return (dispatch, getState) => {
    dispatch(requestSubscriptionsInfo());
    const { cookies, environmentConfig: { api: { mafia } }, routing: { locationBeforeTransitions, locationBeforeTransitions: { search } } } = getState();
    const { auth_token: emailAuthToken } = queryString.parse(search) || {};

    return modifySubscriptionsApi(mafia, subscriptions, cookies, { auth_token: replaceAuthTokenSpace(emailAuthToken) })
      .then(processHeadersMiddleware(setSessionCookies()))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(() => dispatch(fetchSubscriptionsInfo()))
      .catch(authenticationErrorCatchHandlerFactory(dispatch, prependAppRoot('/subscriptions', locationBeforeTransitions)));
  };
}

export function toggleSubscriptionList(emailListName) {
  return {
    type: SUBSCRIPTION_LIST_TOGGLED,
    selectedEmailListName: emailListName
  };
}

export function toggleSubscriptionBrand(id) {
  return {
    type: SUBSCRIPTION_BRAND_TOGGLED,
    selectedBrandId: id
  };
}

export function toggleSubscriptionStock(asin) {
  return {
    type: SUBSCRIPTION_STOCK_TOGGLED,
    selectedAsin: asin
  };
}
